import { Component, Input } from '@angular/core';
import { secondaryListItemConfig } from '../../interfaces/secondaryListItemConfig';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-secondary-list-item',
  standalone: true,
  imports: [CommonModule, RouterLink],
  templateUrl: './secondary-list-item.component.html',
  styleUrl: './secondary-list-item.component.css',
})
export class SecondaryListItemComponent {
  @Input() item: any;
  @Input() config!: secondaryListItemConfig;
  @Input() url?: string;

  get displayName(): string {
    const name = this.item?.[this.config.name];
    return name || `${this.config.entityType} #${this.item?.[this.config.id]}`;
  }

  get displayUser(): string {
    return this.item?.[this.config.userName] || 'Unknown User';
  }

  get displayDate(): any {
    return this.item?.[this.config.date];
  }
}
